const AnswerTypes = {
  Boolean: "TIP-P-001",
  TextEntry: "TIP-P-002",
  NumericEntry: "TIP-P-003",
  SingleSelection: "TIP-P-004",
  MultipleSelection: "TIP-P-005",
  VerticalSingleSelection: "TIP-P-006",
  HorizontalSingleSelection: "TIP-P-007",
  MultipleSelectionWithChildren: "TIP-P-008",
  SimultaneousTextEntry: "TIP-P-009",
  ReadOnly: "ReadOnly",
};

export default AnswerTypes;
